"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuedraggable = _interopRequireDefault(require("vuedraggable"));
var _linkaddress = _interopRequireDefault(require("@/components/linkaddress"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
var _default = exports.default = {
  name: 'c_menu_list',
  props: {
    configObj: {
      type: Object
    },
    configNme: {
      type: String
    },
    index: {
      type: null
    },
    isRub: {
      type: Boolean,
      default: false
    }
  },
  components: {
    draggable: _vuedraggable.default,
    linkaddress: _linkaddress.default
  },
  data: function data() {
    return {
      defaults: {},
      configData: {},
      gridBtn: {
        xl: 4,
        lg: 8,
        md: 8,
        sm: 8,
        xs: 8
      },
      gridPic: {
        xl: 6,
        lg: 8,
        md: 12,
        sm: 12,
        xs: 12
      },
      activeIndex: 0,
      //索引
      indexLast: 0,
      lastObj: {}
    };
  },
  mounted: function mounted() {
    var _this2 = this;
    this.$nextTick(function () {
      _this2.configData = _this2.configObj;
    });
  },
  watch: {
    configObj: {
      handler: function handler(nVal, oVal) {
        this.configData = nVal;
      },
      deep: true
    }
  },
  methods: {
    //状态切换
    onchangeIsShow: function onchangeIsShow(e, index) {
      this.activeIndex = index;
      this.configData.list[this.activeIndex].status = e;
    },
    linkUrl: function linkUrl(e) {
      this.configData.list[this.activeIndex].linkUrl = e;
    },
    getLink: function getLink(index, item) {
      this.activeIndex = index;
      this.$refs.linkaddres.dialogVisible = true;
    },
    handleAddLink: function handleAddLink(index) {
      var data = {
        name: '',
        linkUrl: '',
        id: 0,
        sort: 0,
        modelMaxLength: 8
      };
      var datas = Object.assign({}, data);
      this.configData.list[index].linkList.push(datas);
    },
    //删除链接
    handleLinkDelete: function handleLinkDelete(item, indexs, index) {
      this.configData.list[index].linkList.splice(indexs, 1);
    },
    //添加板块
    handleAddBox: function handleAddBox() {
      var data = JSON.parse(JSON.stringify(this.configData.defaultList));
      this.configData.list.push(data);
    },
    // 点击图文封面
    modalPicTap: function modalPicTap(item, index) {
      this.activeIndex = index;
      var _this = this;
      _this.$modalUpload(function (img) {
        if (!img) return;
        item.img = img[0].sattDir;
        _this.getPic(img[0].sattDir);
      }, false, 'diy');
    },
    // 获取图片信息
    getPic: function getPic(pc) {
      var _this3 = this;
      this.$nextTick(function () {
        _this3.configData.list[_this3.activeIndex].imageUrl = pc;
      });
    },
    onBlur: function onBlur() {
      var data = this.defaults.menuConfig;
      this.defaults.picStyle.picList[this.defaults.picStyle.tabVal].link = data.list[0].info[0].value;
    },
    // 删除整个模块
    handleDelete: function handleDelete(item, index) {
      if (this.configData.list.length == 1) {
        this.lastObj = this.configData.list[0];
      }
      this.configData.list.splice(index, 1);
    }
  }
};